import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import moment from "moment";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import DatePicker from "react-datepicker";

import { departmentSelectOptionRequest } from "../../api/department";
import { createFormRequest, editFormRequest } from "../../api/form";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect";

class TravelForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                employee: null,
                department: null,
                startDate: null,
                endDate: null,
                travelArea: null,
                reason: null,
                approvedBy: null,
            },
            employeeSelectOptions: [],
            departmentSelectOptions: [],
            formErrors: null,
        };
    }

    componentDidMount() {
        // employeeSelectOptionRequest(
        //   result => this.setState({ employeeSelectOptions: result }),
        //   error => this.setState({ error: "There was an error" })
        // );
        departmentSelectOptionRequest(
            (result) => this.setState({ departmentSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
    }

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: value,
            },
        }));
    };

    onChangeDate = (date, field) => {
        let value = moment(date).format("YYYY-MM-DD");

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [field]: value,
            },
        }));
    };

    errorMessage = (name, message) => {
        const { formErrors } = this.state;
        return (
            <>
                {formErrors && formErrors[name] && (
                    <div className="form-text text-danger sz-11px">
                        {message}
                    </div>
                )}
            </>
        );
    };

    validate = () => {
        const { employee, startDate, endDate, approvedBy } =
            this.state.resource;

        const errors = {};
        if (!employee) {
            errors.employee = true;
        }

        if (!startDate) {
            errors.startDate = true;
        }

        if (!endDate) {
            errors.endDate = true;
        }

        if (!approvedBy) {
            errors.approvedBy = true;
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ formErrors: errors });
        } else {
            this.setState({ formErrors: null });
            this.save();
        }
    };

    save = () => {
        const {
            employee,
            department,
            startDate,
            endDate,
            travelArea,
            reason,
            approvedBy,
        } = this.state.resource;

        const { instanceId } = this.props;

        const isNewRecord = !instanceId;

        let data = {
            employee,
            formType: "travel-order",
            department,
            startDate,
            endDate,
            travelArea,
            reason,
            approvedBy,
        };

        if (isNewRecord) {
            createFormRequest(
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        } else {
            editFormRequest(
                instanceId,
                data,
                (result) => this.saveSuccess(),
                (error) => this.saveFailure(),
            );
        }
    };

    saveSuccess = () => {
        const { employee } = this.state.resource;

        this.setState({ error: null });
        this.props.goToList(employee);
    };

    saveFailure = () => {
        this.setState({ error: "There was an error saving tag." });
    };

    handleChange = (employeeValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                employee: employeeValue.value,
            },
        }));
    };

    handleApproveChange = (approveValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                approvedBy: approveValue.value,
            },
        }));
    };

    render() {
        const { department, travelArea, reason } =
            this.state.resource;

        const startDate = this.state.resource.startDate
            ? moment(this.state.resource.startDate, "YYYY-MM-DD").toDate()
            : "";
        const endDate = this.state.resource.endDate
            ? moment(this.state.resource.endDate, "YYYY-MM-DD").toDate()
            : "";

        const { departmentSelectOptions } = this.state;

        return (
            <Row>
                <Col md={12}>
                    <Card
                        title="Travel Form"
                        content={
                            <form>
                                <FormGroup>
                                    <ControlLabel>
                                        Employee
                                        <span className="required-star">*</span>
                                    </ControlLabel>
                                    <EmployeeAsyncSelect
                                        onChange={this.handleChange}
                                    />
                                    {/* <FormControl 
                        onChange={this.handleFormChange}
                        componentClass="select" 
                        name="employee"
                        value={employee}
                      >
                      <option value="">Select</option>
                      {employeeSelectOptions.map(option => {
                          return (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          );
                      })}
                    </FormControl> */}
                                    {this.errorMessage(
                                        "employee",
                                        "Employee can't be empty",
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Department</ControlLabel>
                                    <FormControl
                                        onChange={this.handleFormChange}
                                        componentClass="select"
                                        name="department"
                                        value={department}
                                    >
                                        <option value="">Select</option>
                                        {departmentSelectOptions.map(
                                            (option) => {
                                                return (
                                                    <option
                                                        key={option.value}
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                );
                                            },
                                        )}
                                    </FormControl>
                                </FormGroup>
                                <Row>
                                    <div className="col-md-6">
                                        <FormGroup>
                                            <ControlLabel>
                                                Start Date
                                                <span className="required-star">
                                                    *
                                                </span>
                                            </ControlLabel>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) =>
                                                    this.onChangeDate(
                                                        date,
                                                        "startDate",
                                                    )
                                                }
                                                dateFormat="MM/dd/yyyy"
                                                className="dateInput"
                                                dropdownMode="select"
                                            />
                                            {this.errorMessage(
                                                "startDate",
                                                "Start Date can't be empty",
                                            )}
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-6">
                                        <FormGroup>
                                            <ControlLabel>
                                                End Date
                                                <span className="required-star">
                                                    *
                                                </span>
                                            </ControlLabel>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) =>
                                                    this.onChangeDate(
                                                        date,
                                                        "endDate",
                                                    )
                                                }
                                                dateFormat="MM/dd/yyyy"
                                                className="dateInput"
                                                dropdownMode="select"
                                            />
                                            {this.errorMessage(
                                                "endDate",
                                                "End Date can't be empty",
                                            )}
                                        </FormGroup>
                                    </div>
                                </Row>
                                <FormGroup>
                                    <ControlLabel>Travel Area</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="travelArea"
                                        value={travelArea}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Reason</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="reason"
                                        value={reason}
                                        onChange={this.handleFormChange}
                                        placeholder=""
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>
                                        Approved By
                                        <span className="required-star">*</span>
                                    </ControlLabel>

                                    <EmployeeAsyncSelect
                                        onChange={this.handleApproveChange}
                                        placeholder={"Approved By"}
                                    />
                                    {/* <FormControl
                                        onChange={this.handleFormChange}
                                        componentClass="select"
                                        name="approvedBy"
                                        value={approvedBy}
                                    >
                                        <option value="">Select</option>
                                        {employeeSelectOptions.map((option) => {
                                            return (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </FormControl> */}
                                    {this.errorMessage(
                                        "approvedBy",
                                        "Approved By can't be empty",
                                    )}
                                </FormGroup>

                                <Button
                                    bsStyle="primary"
                                    pullRight
                                    fill
                                    onClick={this.validate}
                                >
                                    Submit Form
                                </Button>
                                <div className="clearfix" />
                            </form>
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default TravelForm;
